import { render, staticRenderFns } from "./SurveySection.vue?vue&type=template&id=3fdd53c5&"
import script from "./SurveySection.vue?vue&type=script&lang=js&"
export * from "./SurveySection.vue?vue&type=script&lang=js&"
import style0 from "./SurveySection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports